module.exports = __webpack_public_path__ + "img/5.7a009e08.png";